export default {

  getLocalMessage: function () {
    return localStorage.getItem("message");
  },

  setLocalMessage: function (message) {
    localStorage.setItem("message", message);
  },

  removeLocalMessage: function () {
    return localStorage.removeItem("message")
  }

}



// WEBPACK FOOTER //
// ./src/services/LocalMessageService.js